import React, {useCallback} from 'react';
import {GatewayGetSchema} from '../../../../../api/DBSchema/Gateway';
import {SMCCheckbox} from '../../../../../components/Simple/SMCCheckbox';
import {useTranslation} from 'react-i18next';
import SMCLabel from '../../../../../components/Simple/SMCLabel';
import EditorLayout from '../../../../../components/Layouts/EditorLayout';

const pageSchema = GatewayGetSchema.pages.managedServices;
const pageId = pageSchema.pageId;

function BaseManagedServices({
    pageData,
    setObjectData,
    pageDisabled
}) {
    const { t } = useTranslation();
    
    const setPageValue = useCallback((param, newValue) => {
        setObjectData([pageId, param], newValue);
    }, [setObjectData]);

    const logs               = pageData[pageSchema.logs];
    const reports            = pageData[pageSchema.reports];
    const firmwareUpgrade    = pageData[pageSchema.firmwareUpgrade];
    const autoBackup         = pageData[pageSchema.autoBackup];
    const dynamicDns         = pageData[pageSchema.dynamicDns];
    const cloudNotifications = pageData[pageSchema.cloudNotifications];


    return (
        <EditorLayout>
            <SMCLabel bold>{t('SMP.PLAN.CREATE_NEW_PLAN.SERVICES_HEADING')}</SMCLabel>
            <SMCCheckbox
                disabled={pageDisabled}
                checked={logs}
                onChange={e => setPageValue(pageSchema.logs, e.target.checked)}
                label={t('SMP.PLAN.CREATE_NEW_PLAN.STORE')}
            />
            <SMCCheckbox
                disabled={pageDisabled}
                checked={reports}
                onChange={e => setPageValue(pageSchema.reports, e.target.checked)}
                label={t('SMP.PLAN.CREATE_NEW_PLAN.SEND_PERIODIC_REPORTS')}
            />
            <SMCCheckbox
                disabled={pageDisabled}
                checked={firmwareUpgrade}
                onChange={e => setPageValue(pageSchema.firmwareUpgrade, e.target.checked)}
                label={t('SMP.PLAN.CREATE_NEW_PLAN.FIRMWARE')}
            />
            <SMCCheckbox
                disabled={pageDisabled}
                checked={autoBackup}
                onChange={e => setPageValue(pageSchema.autoBackup, e.target.checked)}
                label={t('SMP.PLAN.CREATE_NEW_PLAN.PERIODIC_BACKUP')}
            />
            <SMCCheckbox
                disabled={pageDisabled}
                checked={dynamicDns}
                onChange={e => setPageValue(pageSchema.dynamicDns, e.target.checked)}
                label={t('SMP.PLAN.CREATE_NEW_PLAN.DYNAMIC_DNS')}
            />
            <SMCCheckbox
                disabled={pageDisabled}
                checked={cloudNotifications}
                onChange={e => setPageValue(pageSchema.cloudNotifications, e.target.checked)}
                label={t('SMP.PLAN.CREATE_NEW_PLAN.SEND_CLOUD_NOTIFICATIONS')}
            />
        </EditorLayout>
    );
}

export default BaseManagedServices;